<template>
    <!-- 账单明细 -->
    <div  class="bill">
        <div class="san">
            <div class="tab-tit">基本海运费</div>
            <table  v-if="bill_change.boxtype.length>0" class="table datab" border>
                <tr class="theader">
                    <td class="first">费用名称</td>
                    <td>箱型</td>
                    <td>价格</td>
                    <td>货重(kgs)</td>
                    <td>限重</td>
                    <td>限重规则</td>
                    <td class="xiang">单位</td>
                </tr>
                <tr class="tbody" v-for="(item,index) in bill_change.boxtype" :key="index">
                    <td  class="first">基本海运费</td>
                    <td>{{item.box_type}}</td>
                    <td>USD {{Number(item.money) + bill_change.linefee}}</td>
                    <td>{{item.weight}}</td>
                    <td> {{item.overweight==0?'不限重':'限重'}}</td>
                    <td  v-if="item.overweight == 0">--</td>
                    <td class="xiaotab" v-if="item.overweight == 1">
                        <table  class="table">
                            <tr  class="theader">
                                <td>最小重量（kgs）</td>
                                <td>最大重量（kgs）</td>
                                <td>超重费用</td>
                            </tr>
                            <tr  class="tbody"  v-for="(it,ind) in item.weight_limit" :key="ind">
                                <td>{{it.min_weight||'--'}}</td>
                                <td>{{it.max_weight||'--'}}</td>
                                <td>USD {{it.overweight_fees||'--'}}</td>
                            </tr>
                        </table>
                    </td>
                    <td class="xiang xianger">箱</td>
                </tr>
            </table>
            <table v-if="bill_change.boxtype.length==0" class="table datab" border>
                <tr class="theader">
                <td class="first">费用名称</td>
                <td>费用类型</td>
                <td colspan="2">收费单位</td>
                </tr>
                <tr class="tbody">
                    <td class="zanwu" colspan="3">暂无数据</td>
                </tr>
            </table>
            <div class="xiaoji">小计：USD {{bill_change.boxPrice}}</div>
            
            <div class="tab-tit">海运附加费</div>
            <table  v-if="bill_change.surcharge.length>0" class="table datab" border>
                <tr class="theader">
                <td class="first">费用名称</td>
                <td>费用类型</td>
                <td colspan="2">收费单位</td>
                </tr>
                <tr class="tbody" v-for="(item,index) in bill_change.surcharge" :key="index">
                <td  class="first">{{item.surcharge_title}}</td>
                <td>{{item.cost_unit == 1 ? '箱' : '票' }}</td>
                <!-- <td>{{item.fee}}</td> -->
                <td  colspan="2" v-if="item.cost_unit == 2">USD {{item.vote_cost}}</td>
                <td class="xiaotab" v-if="item.cost_unit == 1">

                    <table  class="table">
                    <tr  class="theader">
                        <td v-for="(obj,ind) in item.box_cost" :key="ind">
                        <div v-for="(value, key, idx) in obj" :key="idx">
                            {{ key }}
                        </div>
                        </td>
                    </tr>
                    <tr  class="tbody" >
                        <td v-for="(obj,ind) in item.box_cost" :key="ind">
                        <div v-for="(value, key, idx) in obj" :key="idx">
                            USD {{value}}
                        </div>
                        </td>
                    </tr>
                    </table>
                </td>
                </tr>
            </table>
            <table v-if="bill_change.surcharge.length==0" class="table datab" border>
                <tr class="theader">
                <td class="first">费用名称</td>
                <td>费用类型</td>
                <td colspan="2">收费单位</td>
                </tr>
                <tr class="tbody">
                    <td class="zanwu" colspan="3">暂无数据</td>
                </tr>
            </table>
            <div class="xiaoji">小计：USD {{bill_change.surchargePrice}}</div>

            <!-- <div class="tab-tit">人民币港杂费</div>
            <table v-if="bill_change.other_cost.length>0" class="table datab" border>
                <tr class="theader">
                <td class="first">费用名称</td>
                <td>费用类型</td>
                <td colspan="2">收费单位</td>
                </tr>
                <tr class="tbody" v-for="(item,index) in bill_change.other_cost" :key="index">
                    <td  class="first">{{item.surcharge_title}}</td>
                    <td>{{item.cost_unit == 1 ? '箱' : '票' }}</td>
                    <td  colspan="2" v-if="item.cost_unit == 2">CNY {{item.vote_cost}}</td>
                    <td class="xiaotab" v-if="item.cost_unit == 1">

                        <table  class="table">
                        <tr  class="theader">
                            <td v-for="(obj,ind) in item.box_cost" :key="ind">
                            <div v-for="(value, key, idx) in obj" :key="idx">
                                {{ key }}
                            </div>
                            </td>
                        </tr>
                        <tr  class="tbody" >
                            <td v-for="(obj,ind) in item.box_cost" :key="ind">
                            <div v-for="(value, key, idx) in obj" :key="idx">
                                CNY {{value}}
                            </div>
                            </td>
                        </tr>
                        </table>
                    </td>
                </tr>
            </table>
            <table v-if="bill_change.other_cost.length==0" class="table datab" border>
                <tr class="theader">
                <td class="first">费用名称</td>
                <td>费用类型</td>
                <td colspan="2">收费单位</td>
                </tr>
                <tr class="tbody">
                    <td class="zanwu" colspan="3">暂无数据</td>
                </tr>
            </table>
            <div class="xiaoji">小计：CNY {{bill_change.otherPrice}}</div> -->

            <!-- <div class="tab-tit" v-show="bill_change.linefee * bill_change.boxtype.length>0">服务费</div>
            <table  v-show="bill_change.linefee * bill_change.boxtype.length>0" class="table datab" border>
                <tr class="theader">
                <td class="first">费用名称</td>
                <td colspan="2">收费单位</td>
                </tr>
                <tr class="tbody">
                    <td>服务费</td>
                    <td>USD {{bill_change.linefee * bill_change.boxtype.length}}</td>
                </tr>
            </table>
            <div  v-show="bill_change.linefee * bill_change.boxtype.length>0" class="xiaoji">小计：USD {{bill_change.linefee * bill_change.boxtype.length}}</div> -->

        </div>

        <div class="zongji">
            <div class="left">
                <div>账单总计：
                    <span>
                        USD {{ bill_change.boxPrice + bill_change.surchargePrice }} 
                        <!-- + CNY {{ bill_change.otherPrice}} -->
                    </span>
                </div>
                <div class="yugu">
                    <i class="el-icon-info"></i>
                    <div>以上费用为预估费用，最终以实际账单为准</div>
                </div>
            </div>
            <div class="right">
                <!-- <el-button class="yulan">预览</el-button> -->
                <el-button class="daochu" @click="daochu">导出</el-button>
                <el-button  @click="biandong" class="biandong">账单变动</el-button>
            </div>
        </div>

         <!-- 账单变动弹窗 -->
        <el-dialog title="账单变动" center :visible.sync="dialogTableVisible">
            <el-table
                :data="billList"
                style="width: 100%"
                :header-cell-style="{ background: '#f9f9f9' }"
            >
                <el-table-column prop="cost_name" label="费用名称"> </el-table-column>
                <el-table-column prop="cost_unit" label="单位"> </el-table-column>
                <el-table-column prop="old_price" label="原价格"> </el-table-column>
                <el-table-column prop="new_price" label="变动价格"> </el-table-column>
                <el-table-column label="驳回原因" prop="reject_reason"/>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <div v-if="scope.row.is_check==1">
                            <el-button type="text" class="queren" @click="queren(scope.row.id)">确认</el-button>
                                <span class="xie">
                                    /
                                </span>
                            <el-button type="text" class="bohui" @click="bohui(scope.row.id)">驳回</el-button>
                        </div>
                        <div v-if="scope.row.is_check==2"  class="queren">
                            已确认
                        </div>
                        <div v-if="scope.row.is_check==3" class="bohui">
                            已驳回
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="dialogPageno"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="dialogPagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="dialogTotal"
            >
            </el-pagination>
        </el-dialog>

        <!-- 驳回原因 -->
        <el-dialog
        title="驳回原因"
        center
        :visible.sync="reasonDialog"
        width="30%">
        <el-form :model="form">
            <el-form-item label="驳回原因" >
                <el-input v-model="form.reject_reason" autocomplete="off"></el-input>
            </el-form-item>
        </el-form>
        <div class="dialog-line"></div>
        <div  class="dialog-footer">
            <el-button class="dialog-guanbi" @click="reasonDialog = false">关闭</el-button>
            <el-button class="dialog-renzheng" @click="submit">确认</el-button>
        </div>
        </el-dialog>
    </div>
</template>
    
<script>
import { billChangeLists,checkBillChange,exportBill } from "@/api/api";
export default {
    props:{
        bill_change:{
            type:Object,
            required:true
        }
    },
    components:{
    },
    data() {
        return {
            // 账单变动弹窗打开状态
            dialogTableVisible:false,
            order_id: sessionStorage.getItem('itemId'),
            billList:[],
            headers:{
                token: localStorage.getItem('token')
            },
            form:{
                order_id:sessionStorage.getItem('itemId'),
                change_id:'',
                is_check:'',
                reject_reason:'',
            },
            reasonDialog:false,
            dialogPageno:1,
            dialogPagesize:10,
            dialogTotal:0,
        }
    },
    methods: {
        handleSizeChange(val){
            this.dialogPagesize=val
            this.getList()
        },
        handleCurrentChange(val){
            this.dialogPageno=val
            this.getList()
        },
        biandong(){
            this.dialogTableVisible = true
            this.getList()
        },
        async getList(){
            try {
                const res = await billChangeLists({
                    order_id: this.$route.query.id,
                    page_no:this.dialogPageno,
                    page_size:this.dialogPagesize
                },this.headers)
                if(res.code==1){
                    this.billList = res.data.lists
                    this.dialogTotal = res.data.count
                }
            } catch (error) {
                console.log(error,'失败');
            }
        },
        queren(index){
            this.form.change_id = index 
            this.form.is_check = 2 
            this.submit()
        },
        bohui(index){
            this.form.change_id = index 
            this.form.is_check = 3
            this.reasonDialog = true

        },
        async submit(){
            if(this.form.is_check == 3){
                if(this.form.reject_reason == ''){
                    this.$message({
                        message: "请输入驳回原因",
                        type: "error",
                    });
                }else{
                    this.reasonDialog = false
                }
            }

            try {
                const res = await checkBillChange(this.form,this.headers)
                if(res.code == 1){
                    this.$message({
                        message: "成功",
                        type: "success",
                    });
                    this.dialogTableVisible = false
                }else{
                    this.$message({
                        message: res.msg,
                        type: "error",
                    });
                }
            } catch (error) {
                console.log(error,'失败');
            }
        },
        async daochu(){
            try {
                const res = await exportBill({
                    order_id: this.order_id
                },this.headers)
                if(res.code==1){
                    // this.form = res.data
                    this.$message({
                        type:'success',
                        message:'导出成功'
                    })
                    const link = document.createElement('a');
                    link.href = res.data.url;
                    link.setAttribute('download', '');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }else{
                    this.$message({
                        type:'error',
                        message:'导出失败'
                    })
                }
            } catch (error) {
                console.log(error,'失败');
            }
        },
    },
    mounted(){
        

        
    }
}
</script>
    
<style style lang="scss" scoped>
.san{
    .tit{
        font-size: 18px;

        margin-top: 24px;
        margin-bottom: 18px;
    }
}

.xiaoji{
    text-align: right;
    margin-top: 18px;
}
.zongji{
    height: 80px;
    background: #fff;
    border-top: 1px solid#eee;

    display: flex;
    justify-content: space-between;
    align-items: center;

    margin-top: 32px;
    .left{
        margin-left: 32px;
        .yugu{
            display: flex;
            align-items: center;

            color: #999;
            font-size: 14px;

            margin-top: 8px;
            
        }
        span{
            color: #FE3300;
        }
    }

    .right{
        margin-right: 32px;

        .el-button{
            width: 100px;
            height: 40px;
            border-radius: 8px 8px 8px 8px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            font-style: normal;
            text-transform: none;
            border: 0;
        }
        .yulan{
            color: #0073F5;
        }
        .daochu{
            color: #0073F5;
            border: 1px solid #0073F5;
            margin-left: 16px;
        }
        .biandong{
            background: #0073F5;
            border-radius: 8px 8px 8px 8px;
            color: #fff;
            margin-left: 16px;
        }
    }
}

.table{
    width: 100%;
    border-spacing: 0;
    border-collapse: collapse;

    .xiang{
        width: 80px;
    }

    .xianger{
        text-align: center;
    }
    
    td{
      padding-left: 12px;
    }
    .theader{
        height: 48px;
        background: #F9F9F9;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #999999;
        font-style: normal;
        text-transform: none;
        
    }
    .tbody{
        height: 68px;
        background: #fff;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        font-style: normal;
        text-transform: none;

        .zanwu{
            color: #999;
            text-align: center;
            font-size: 14px;
        }
    }
}
.datab{
  margin-top: 20px;
  border: solid 1px #eee;

  .xiaotab{
    padding: 0;
  }
}
.queren{
    color: #0073F5;
    font-size: 14px;
    margin: 0;
}

.bohui,.bohui:hover,.bohui:active{
    color: #FE3300;
    font-size: 14px;
    margin: 0;
}

.xie{
    color: #999;
}

.dialog-footer{
  text-align: right;
  .dialog-guanbi{
    width: 120px;
    height: 48px;
    background: #F9F9F9;
    border-radius: 8px 8px 8px 8px;
    font-size: 16px;
    color: #999999;
    border: 0;
  }

  .dialog-renzheng{
    width: 120px;
    height: 48px;
    background: #0073F5;
    border-radius: 8px 8px 8px 8px;
    font-size: 16px;
    color: #FFFFFF;
  }
}

.el-pagination{
    margin-top: 24px;
    text-align: right;
}
</style>